module.exports = __webpack_public_path__ + "img/icon-english.cea7c5d7.png";